export function PageHeader({ eyebrow, title, subtitle, action, accent }) {
  return (
    <header className="mb-10 lg:mb-14 flex items-end justify-between gap-6 flex-wrap">
      <div className="max-w-3xl">
        {eyebrow && <div className="eyebrow mb-3">{eyebrow}</div>}
        <h1 className="text-4xl lg:text-5xl leading-[1.02] tracking-tight font-semibold" data-testid="page-title">
          {accent ? <>{title.split(accent)[0]}<span className="editorial grad-text">{accent}</span>{title.split(accent)[1]}</> : title}
        </h1>
        {subtitle && <p className="mt-4 text-base" style={{ color: "var(--ink-2)", maxWidth: "60ch" }}>{subtitle}</p>}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </header>
  );
}
